module.exports = __webpack_public_path__ + "img/applestore.a467a704.png";